import { IRootState } from '../../../store'
import { IPatientSearchState } from '../store/patientSearch.types'

export const getPatientSearchState = (state: IRootState): IPatientSearchState => state.patientSearch
